import { Checkbox } from "@material-tailwind/react";

export function CheckboxLabel() {
  return <Checkbox label="Remember Me" />;
}
